import { Camera, Sparkles, Send } from "lucide-react";

const STEPS = [
  {
    icon: Camera,
    step: "01",
    title: "Snap a photo",
    text: "Point your camera at anything you want to sell — one shot is enough.",
    testId: "step-snap",
  },
  {
    icon: Sparkles,
    step: "02",
    title: "AI does the work",
    text: "Sellcraft identifies the item, estimates a price from real sold comparables and writes the listing for you.",
    testId: "step-ai",
  },
  {
    icon: Send,
    step: "03",
    title: "Post in one tap",
    text: "Publish to eBay directly — with calculated shipping — or share to Facebook and Gumtree in a single tap.",
    testId: "step-post",
  },
];

const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="section-anchor border-t border-divider bg-surface2/40 py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <p className="font-display text-sm font-semibold uppercase tracking-widest text-brand-light">How it works</p>
      <h2 className="mt-3 font-display text-3xl font-bold uppercase tracking-wide text-onsurface sm:text-4xl">
        Three steps. Thirty seconds.
      </h2>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {STEPS.map(({ icon: Icon, step, title, text, testId }) => (
          <div
            key={step}
            data-testid={testId}
            className="group relative rounded-lg border border-line bg-surface2 p-8 transition-colors duration-200 hover:border-brand-light/60"
          >
            <span className="absolute right-6 top-6 font-display text-4xl font-bold text-surface3 transition-colors group-hover:text-brand-tint">{step}</span>
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-tint">
              <Icon className="h-6 w-6 text-brand-tinttext" />
            </div>
            <h3 className="mt-6 font-display text-xl font-semibold uppercase tracking-wide text-onsurface">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-onsurface2">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
